import { stripOrgRepoFromWorkspacePath } from './stripOrgRepoFromWorkspacePath';

type ToolCallWithInput = {
  readonly input?: unknown;
};

function getInputString(input: unknown, key: string): string | undefined {
  if (typeof input !== 'object' || input === null || !(key in input)) {
    return undefined;
  }
  const value = (input as Record<string, unknown>)[key];
  return typeof value === 'string' && value.length > 0 ? value : undefined;
}

/**
 * Adds `displayPath` / `displayTrashPath` for forge-filesystem tool-call i18n templates.
 */
export function enrichForgeFilesystemToolCall(
  toolCall: ToolCallWithInput,
): Record<string, unknown> {
  const context: Record<string, unknown> = {};
  const path = getInputString(toolCall.input, 'path');
  if (path !== undefined) {
    context.displayPath = stripOrgRepoFromWorkspacePath(path);
  }

  const trashPath = getInputString(toolCall.input, 'trash_path');
  if (trashPath !== undefined) {
    context.displayTrashPath = stripOrgRepoFromWorkspacePath(trashPath);
  }

  return context;
}
